import {
  fetch
} from '@/plugin/axios/index.js'
import formAxios from '@/plugin/axios/formAxios.js'

/**
 * @param {Object} data
 * 列表列表
 */
export function getPayableList(data) {
  return fetch({
    url: '/financial/payable/pageList',
    method: 'POST',
    data
  })
}


export function collectPayableList(data) {
  return fetch({
    url: '/financial/payable/collectPayableList',
    method: 'POST',
    data
  })
}


/**
 * @param {Object} data
 * 删除单据
 */
export function deletePayable(data) {
  return fetch({
    url: '/financial/payable/delete',
    method: 'POST',
    data
  })
}

/**
 * @param {Object} data
 * 保存单据
 */
export function savePayable(data) {
  return fetch({
    url: '/financial/payable/save',
    method: 'POST',
    data
  })
}

/**
 * @param {Object} data
 * 保存单据
 */
export function savePayableList(data) {
  return fetch({
    url: '/financial/payable/patchSaveFinancialPayable',
    method: 'POST',
    data: {
      "financialPayableList": data
    }
  })
}
/**
 * @param {Object} data
 * 通过审核
 */
export function passPayable(data) {
  return fetch({
    url: '/financial/payable/pass',
    method: 'POST',
    data
  })
}


export function userSimpleList(data) {
  return fetch({
    url: '/auth/user/simpleList',
    method: 'POST',
    data
  })
}

export function getTurnoverList(data) {
  return fetch({
    url: '/financial/card/getTurnoverList',
    method: 'POST',
    data
  })
}





// WEBPACK FOOTER //
// ./src/api/Payable/index.js